"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduleMatrixData = void 0;
const types_1 = require("../types");
const getScheduleMatrixData = (rows, rowsVisibility) => {
    return [
        rowsVisibility[types_1.SCHEDULE_ROW.first] && rows.rowFirstScheduleValue,
        rowsVisibility[types_1.SCHEDULE_ROW.second] && rows.rowSecondScheduleValue,
        rowsVisibility[types_1.SCHEDULE_ROW.third] && rows.rowThirdScheduleValue,
    ].filter(Boolean);
};
exports.getScheduleMatrixData = getScheduleMatrixData;
//# sourceMappingURL=getScheduleMatrixData.js.map